import React from "react"
import { CreateGroupForm } from "@/components/forms"
import type { CreateGroupStepProps } from "./CreateGroupStep.types"

export const CreateGroupStep: React.FunctionComponent<CreateGroupStepProps> = ({
  onSuccess,
}) => {
  return <CreateGroupForm onSuccess={onSuccess} />
}
